<div class="custom-status-container" *ngIf="!isLoadingLabels && !isLoadingAllStatus">
	<div class="search" *ngIf="selectedStatus.id == -1">
		<cpi-input-with-autocomplete
			[availableOptions]="allStatusIAC"
			[keepValue]="false"
			[minInputLength]="0"
			[placeholder]="labels.lbl_geral_buscar + ' ' + labels.lbl_geral_status"
			(onValueChange)="selectStatus($event)">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="allStatus"
			[height]="'60dvh'"
			[itemPadding]="'1%'"
			[insideSort]="true"
			[labels]="labels"
			(getSelectedItem)="selectStatus($event[0]['status'])">
		</cpi-msp-table>
	</div>

	<ng-container *ngIf="selectedStatus.id != -1">
		<div class="header-wrap">
			<span class="tab selected">{{ labels.lbl_personalizacao_status }}</span>
		</div>

		<div class="body-wrap">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_nome }}</span>
				<input [value]="selectedStatus.status" (input)="selectedStatus.status = $event.target.value" disabled />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_nome_customizado }} *</span>
				<input [value]="selectedStatus.label" (input)="selectedStatus.label = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_desativado }}</span>
				<cpi-checkbox
					[value]="selectedStatus.notAllowed"
					[innerText]="selectedStatus.notAllowed == true ? labels.lbl_geral_sim : labels.lbl_geral_nao"
					(oValue)="selectedStatus.notAllowed = $event">
				</cpi-checkbox>
			</div>

			<div class="button-container">
				<div class="button" (click)="cleanSelected()">{{ labels.lbl_geral_voltar }}</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingStatus }"
					(click)="createCustomStatus()"
					*ngIf="selectedStatus.id == 0">
					{{ labels.lbl_geral_atualizar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingStatus"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingStatus }"
					(click)="updateCustomStatus()"
					*ngIf="selectedStatus.id != -1 && selectedStatus.id != 0">
					{{ labels.lbl_geral_atualizar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingStatus"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingAllStatus"></cpi-dot-bounce-loading-effect>
